/**
 * Footer columns collapse into accordions on a phone and sit open as columns
 * above the breakpoint. The markup ships with every <details> open, so without
 * this script the footer is simply fully expanded rather than unusable.
 */
class FooterAccordions extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-footer-accordion]'));
    if (!this.items.length) return;

    this.mq = window.matchMedia('(min-width: 750px)');
    this.items.forEach((item) => {
      item.dataset.wasOpen = 'false';
    });

    // `toggle` does not bubble, so listen in the capture phase.
    this.addEventListener(
      'toggle',
      (event) => {
        const item = event.target;
        if (!item.matches('[data-footer-accordion]')) return;
        if (!this.mq.matches) item.dataset.wasOpen = String(item.open);
      },
      true
    );

    this.apply = this.apply.bind(this);
    this.apply();
    this.mq.addEventListener('change', this.apply);
  }

  disconnectedCallback() {
    if (this.mq) this.mq.removeEventListener('change', this.apply);
  }

  apply() {
    const wide = this.mq.matches;
    this.items.forEach((item) => {
      // Collapsing on a phone restores whatever the visitor had open, so a
      // rotation does not throw away where they were.
      item.open = wide ? true : item.dataset.wasOpen === 'true';
    });
  }
}

if (!customElements.get('footer-accordions')) {
  customElements.define('footer-accordions', FooterAccordions);
}
